import wixLocation from 'wix-location'
import wixSeo from 'wix-seo'
import wixWindow from 'wix-window'
import { getFeatures, addVote, removeVote, getVotes } from 'backend/FeatureFlow'
import { STATUSES, SOURCES, BI_INPUTS } from 'public/featureFlowConsts.js'
import { styleHtmlForDisplay } from 'public/utils.js'
import forIn from 'lodash/forIn'

import { BI_EVENTS } from 'public/biConsts'
import { sendBi } from 'public/biModule'

// roadmap default constatnts
const wishlistDefaultStatuses = ['Planning', 'InDevelopment', 'RollingOut']
const pageSize = 10

let statusSelector

let initialPageTitle

$w.onReady(function () {

	if (wixWindow.rendering.env !== 'browser') {
		const queryDefinition = {
			pageSize,
			pageIndex: 0,
			statuses: wishlistDefaultStatuses,
			excludeSubmittingUser: true
		}

		return getFeatures(queryDefinition).then(({ items: features }) => {
			return features
		})
	}
	initiatePageUI()
	const features = loadAndDisplayFeatures().then(_features => {
		return _features
	})
	populateFeatureItemData()

})

// Roadmap | Velo | Wix.com

const initiatePageUI = () => {
	// status filter
	statusSelector = createStatusSelector()
	statusSelector.onClick(() => {
		$w('#pagination').currentPage = 1
		loadAndDisplayFeatures()

		sendBi(BI_EVENTS.STATUS_CHANGED, Object.assign({
			topic: statusSelector.getValue()
		}, BI_INPUTS))

	})

	// pagination
	$w('#pagination').currentPage = 1
	$w('#pagination').onChange(async () => {
		loadAndDisplayFeatures()
		await $w('#topAnchor').scrollTo()
	})

	initialPageTitle = wixSeo.title
}

const addCurrentPageToTitle = (currentPage) => {
	const title = (currentPage === 1) ? initialPageTitle : `${initialPageTitle} - Page ${currentPage}`
	wixSeo.setTitle(title)
}

const setPaginationCoverLinks = () => {

	const pageNumber = $w('#pagination').currentPage
	const totalPages = $w('#pagination').totalPages
	const nextPageNumber = pageNumber + 1
	const prevPageNumber = pageNumber - 1
	const urlWithoutQueryParams = wixLocation.url.split('?')[0]

	if (nextPageNumber <= totalPages) {
		const nextUrl = `${urlWithoutQueryParams}?page=${nextPageNumber}`
		$w('#paginationNextCover').link = nextUrl
		$w('#paginationNextCover').show()
	} else {
		$w('#paginationNextCover').hide()
	}

	if (prevPageNumber > 0) {
		const prevUrl = (prevPageNumber === 1) ? urlWithoutQueryParams : `${urlWithoutQueryParams}?page=${prevPageNumber}`
		$w('#paginationPrevCover').link = prevUrl
		$w('#paginationPrevCover').show()
	} else {
		$w('#paginationPrevCover').hide()
	}

}

const loadAndDisplayFeatures = async () => {
	const { features, totalCount } = await getDesiredFeatures()

	$w('#featureRepeater').data = features

	const totalPages = totalCount > 0 ? Math.ceil(totalCount / pageSize) : 1
	$w('#pagination').totalPages = totalPages

	setPaginationCoverLinks()

	await $w('#topAnchor').scrollTo()

	return features
}

function setTag($item, index, title, color) {
	$item(`#tag${index}Color`).show()
	$item(`#tag${index}Title`).text = title
	$item(`#tag${index}Color`).style.backgroundColor = color
}

const getDesiredFeatures = async () => {
	const selectedStatus = statusSelector.getValue()
	const pageNumber = $w('#pagination').currentPage

	const queryDefinition = {
		pageSize,
		pageIndex: pageNumber - 1,
		statuses: selectedStatus === 'All' ? wishlistDefaultStatuses : [selectedStatus],
		excludeSubmittingUser: true
	}

	const { items: features, totalCount } = await getFeatures(queryDefinition)

	return { features, totalCount }
}

const setExpandAnimation = (container, button) => {
	const descriptionCollaped = container.collapsed

	if (descriptionCollaped) {
		container.expand()
		container.show()
		button.label = '-'
	} else {
		container.hide()
		container.collapse()
		button.label = '+'
	}
}

const populateFeatureItemData = () => {
	$w('#featureRepeater').onItemReady(($item, itemData) => {

		const styledDescription = styleHtmlForDisplay(itemData.description)

		$item('#featureTitle').text = itemData.title
		$item('#featureDescription').html = styledDescription

		const source = SOURCES[itemData.source]
		const status = STATUSES[itemData.status]
		if (itemData.source === 'Community') {
			setTag($item, 1, source.label, source.color)
			setTag($item, 2, status.label, status.color)
		} else {
			setTag($item, 1, status.label, status.color)
		}

		$item('#contentElements').show()
		$item('#loadingPlaceholder').hide()

		$item('#toggleDescriptionBtn').onClick((event) => {

			setExpandAnimation($item('#descriptionContainer'), $item('#toggleDescriptionBtn'))

			sendBi(BI_EVENTS.ROADMAP_OPEN_CLOSE_COLLAPSABLE, Object.assign({
				tags: `${itemData.source}, ${itemData.status}`,
				topic: statusSelector.getValue()
			}, BI_INPUTS))
		})
	})
}

const createStatusSelector = () => {
	let selected = 'All'

	const selectedColor = '#3637F5'
	const unselectedColor = '#000000'

	const statusOptionsToUIData = {
		All: {
			value: 'All',
			buttonId: 'allBtn',
			arrowId: 'allArrow'
		},
		Planning: {
			value: 'Planning',
			buttonId: 'planningBtn',
			arrowId: 'planningArrow'
		},
		InDevelopment: {
			value: 'InDevelopment',
			buttonId: 'inDevBtn',
			arrowId: 'inDevArrow'
		},
		RollingOut: {
			value: 'RollingOut',
			buttonId: 'inBetaBtn',
			arrowId: 'inBetaArrow'
		}
	}

	// set selected UI
	const select = (status) => {
		const { buttonId, arrowId } = statusOptionsToUIData[status]

		$w(`#${buttonId}`).style.color = selectedColor
		$w(`#${arrowId}`).show()
		selected = status
	}

	// set selected UI
	const unselect = (status) => {
		const { buttonId, arrowId } = statusOptionsToUIData[status]

		$w(`#${buttonId}`).style.color = unselectedColor
		$w(`#${arrowId}`).hide()
		selected = undefined
	}

	forIn(statusOptionsToUIData, ({ buttonId, arrowId }, status) => {
		$w(`#${buttonId}`).onClick(() => {
			const isSelected = $w(`#${buttonId}`).color === selectedColor

			if (isSelected) return // do nothing when button is already selected

			unselect(selected)
			select(status)
		})
	})

	return {
		getValue: () => statusOptionsToUIData[selected].value,
		onClick: (subscriber) => {
			forIn(statusOptionsToUIData, ({ buttonId }) => {
				$w(`#${buttonId}`).onClick(subscriber)
			})
		}
	}
}